import { render, staticRenderFns } from "./ListasPrecios.vue?vue&type=template&id=13c97ee3&scoped=true&"
import script from "./ListasPrecios.vue?vue&type=script&lang=js&"
export * from "./ListasPrecios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c97ee3",
  null
  
)

export default component.exports